import { ReactElement, memo } from 'react'
import { Link } from 'react-router-dom'

import { useGetMenuItems, useI18n } from '../../../hooks'
import { useAppSelector } from '../../../store'
import { StaticNavItems } from '../../../types'
import { getCategoryQuery, isIE } from '../../../utils'
export type ItemProps = {
  role: string
  href: string
  target?: string
  title: string
  dropdownMenu?: { title: string; url: string; external?: boolean; hiddenWhenUserIsGuest?: boolean }[]
  shopDropdown?: boolean
}

const ShopDropdown = () => {
  const { categories } = useAppSelector((state) => state.categoryReducer)
  const { t } = useI18n()

  const staticNavItems = useGetMenuItems({ staticNavItems: true }) as StaticNavItems

  const handleCategoryClick = () => {
    const dropdownContainer = document.querySelector('.nav-shop-dorpdown-menu') as HTMLElement
    if (dropdownContainer) {
      dropdownContainer.style.display = 'none'
      setTimeout(() => {
        dropdownContainer.style.display = 'flex'
      }, 100)
    }
  }
  return (
    <div className="nav-shop-dorpdown-menu">
      <div key={staticNavItems.title} className="nav-shop-dorpdown-menu-column">
        <Link to={staticNavItems.url} key={staticNavItems.title + '-nav'} onClick={handleCategoryClick}>
          <p className="nav-shop-dorpdown-menu-nav">{staticNavItems.title.toUpperCase()}</p>
        </Link>
        {staticNavItems.items.map((subnav, index) =>
          index < 6 ? (
            <Link to={subnav.url} key={subnav.id + index} onClick={handleCategoryClick}>
              <p className="nav-shop-dorpdown-menu-subnav">{subnav.title}</p>
            </Link>
          ) : null
        )}
        <Link to={staticNavItems.url} key={staticNavItems.title + '-viewAll'} onClick={handleCategoryClick}>
          <p className="nav-shop-dorpdown-menu-all">{t('Common_viewAll')}</p>
        </Link>
      </div>
      {categories.map((item) => (
        <div key={item.name} className="nav-shop-dorpdown-menu-column">
          <Link
            onClick={handleCategoryClick}
            to={`/shop?category=${getCategoryQuery(item.name)}&categoryId=${item.siteCategoryId}`}
            key={item.name + '-nav'}
          >
            <p className="nav-shop-dorpdown-menu-nav">{item.name.toUpperCase()}</p>
          </Link>
          {item.producerList?.map((subnav, index) =>
            index < 6 ? (
              <Link
                to={`/shop?category=${getCategoryQuery(item.name)}&categoryId=${item.siteCategoryId}&publisher=${getCategoryQuery(subnav)}`}
                key={subnav}
                onClick={handleCategoryClick}
              >
                <p className="nav-shop-dorpdown-menu-subnav">{subnav}</p>
              </Link>
            ) : null
          )}
          <Link
            to={`/shop?category=${getCategoryQuery(item.name)}&categoryId=${item.siteCategoryId}`}
            key={item.name + '-viewAll'}
            onClick={handleCategoryClick}
          >
            <p className="nav-shop-dorpdown-menu-all">{t('Common_viewAll')}</p>
          </Link>
        </div>
      ))}
    </div>
  )
}

const NavBarItem = (props: ItemProps): ReactElement => {
  const { href, target, title, dropdownMenu, shopDropdown, role } = props

  return (
    <li
      className={`nav-item-${role || title} navbar-item`}
      id={`navbar-${role || title}`}
      onFocus={isIE() ? (e) => e.currentTarget.classList.add('focused-nav-item') : undefined}
      onBlur={isIE() ? (e) => e.currentTarget.classList.remove('focused-nav-item') : undefined}
    >
      {dropdownMenu || shopDropdown ? (
        <Link data-content={title} {...{ to: href, target }}>
          {title}
        </Link>
      ) : (
        <Link data-content={title} {...{ to: href, target }}>
          {title}
        </Link>
      )}
      <div className="nav-item-boarder"></div>
      {dropdownMenu && (
        <div className="nav-item-dorpdown-menu">
          {dropdownMenu.map(({ title, url }, i) => (
            <Link key={`dropdown-menu-${i}`} to={url}>
              {title}
            </Link>
          ))}
        </div>
      )}
      {shopDropdown && <ShopDropdown />}
    </li>
  )
}

export default memo(NavBarItem)
